import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { p as props } from './componentEl-fcbc301e.js';
import { a as addClassNames, c as classNamePropTypes } from './classNames-1ed461aa.js';
import { a as addSpacingClasses, m as marginPropTypes } from './spacing-0f39ba4a.js';

function FormHelperText({
  componentEl: Component,
  className,
  children,
  margin,
  error,
  ...otherProps
}) {
  let cssClasses = ['st_formhelpertext'];
  cssClasses = addClassNames(className, cssClasses);

  // because we have a last-child rule, we need to add a class when no margin override is set
  // so that we can also remove that last-child rule
  if (margin) {
    cssClasses = addSpacingClasses({
      margin,
      cssClasses
    });
  } else {
    cssClasses = addClassNames('st_formhelpertext--default-m', cssClasses);
  }
  if (error) cssClasses.push('st_formhelpertext--error');
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}
FormHelperText.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: props,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for box, if any */
  margin: marginPropTypes,
  /** whether this is an error message or regular message */
  error: PropTypes.bool
};
FormHelperText.defaultProps = {
  componentEl: 'p',
  className: null,
  margin: null,
  error: false
};

export { FormHelperText as F };
